// Mock data for Chinese Writing Toolbox
// Systematic naming for future Supabase backend migration

export const writingToolboxCategories = {
  essayTypes: {
    id: 'essay_types',
    name: '文章類型',
    items: [
      { id: 'formal_essay', name: '正式論文', description: '學術性、結構嚴謹的論文' },
      { id: 'feature_article', name: '特色文章', description: '具有特色的專題文章' },
      { id: 'letter_email', name: '書信/電子郵件', description: '正式或非正式的信件' },
      { id: 'diary_reflection', name: '日記/反思', description: '個人反思和記錄' },
      { id: 'speech', name: '演講稿', description: '公開演講的文稿' },
      { id: 'review_survey', name: '評論/問卷', description: '評論文章或問卷調查' },
      { id: 'instruction_manual', name: '指導/說明文', description: '說明和指導性文章' }
    ]
  },
  
  audiences: {
    id: 'audiences',
    name: '受眾類型',
    items: [
      { id: 'school_audience', name: '學校（老師、校長、同學）', description: '教育環境中的讀者' },
      { id: 'magazine_newspaper', name: '雜誌/報紙讀者', description: '大眾媒體的讀者' },
      { id: 'blog_readers', name: '部落格讀者', description: '網路部落格的讀者' },
      { id: 'competition_judges', name: '比賽評審', description: '比賽或競賽的評審' },
      { id: 'general_public', name: '一般大眾', description: '廣泛的社會大眾' }
    ]
  },
  
  tones: {
    id: 'tones',
    name: '語調風格',
    items: [
      { id: 'formal', name: '正式', description: '正式、嚴謹的語調' },
      { id: 'friendly', name: '友善', description: '親切、友好的語調' },
      { id: 'persuasive', name: '說服性', description: '具有說服力的語調' },
      { id: 'reflective', name: '反思性', description: '深思熟慮的語調' },
      { id: 'informative', name: '資訊性', description: '提供資訊的語調' },
      { id: 'encouraging', name: '鼓勵性', description: '激勵人心的語調' }
    ]
  },
  
  requiredElements: {
    id: 'required_elements',
    name: '必需元素',
    items: [
      { id: 'express_opinion', name: '表達意見', description: '明確表達個人觀點' },
      { id: 'state_reasons', name: '陳述理由', description: '提供充分的理由' },
      { id: 'provide_examples', name: '提供例證', description: '舉出具體例子' },
      { id: 'suggest_improvements', name: '建議改進', description: '提出改進建議' },
      { id: 'reflect_experience', name: '反思經驗', description: '反思個人經驗' },
      { id: 'discuss_pros_cons', name: '討論利弊', description: '分析優缺點' },
      { id: 'propose_suggestions', name: '提出建議', description: '提供具體建議' },
      { id: 'respond_situation', name: '回應情況', description: '針對特定情況回應' }
    ]
  },
  
  supportingDetails: {
    id: 'supporting_details',
    name: '支撐細節',
    items: [
      { id: 'facts_statistics', name: '事實/統計數據', description: '客觀的事實和數據' },
      { id: 'real_examples', name: '真實例子', description: '具體的真實案例' },
      { id: 'personal_experience', name: '個人經驗', description: '個人親身經歷' },
      { id: 'expert_opinion_quote', name: '專家意見或引文', description: '權威專家的觀點' },
      { id: 'comparison_contrast', name: '比較或對比', description: '比較分析不同觀點' },
      { id: 'description', name: '描述（情境、感受或行動）', description: '詳細的描述性內容' }
    ]
  },
  
  selfCheckItems: {
    id: 'self_check_items',
    name: '自我檢查項目',
    items: [
      { id: 'answer_all_parts', name: '我是否回答了問題的每個部分？', description: '確保完整回答所有問題' },
      { id: 'clear_introduction', name: '我的開頭是否清楚？', description: '檢查開頭是否明確' },
      { id: 'focused_paragraphs', name: '每個段落是否重點明確且有充分支撐？', description: '確保段落結構完整' },
      { id: 'relevant_examples', name: '例子和證據是否相關？', description: '檢查例子的相關性' },
      { id: 'appropriate_language', name: '我是否使用了適當的語言和語調？', description: '確保語言風格適當' },
      { id: 'strong_conclusion', name: '我的結論是否有力？', description: '檢查結論的有效性' },
      { id: 'spelling_grammar', name: '我是否檢查了拼寫和語法？', description: '確保文字正確性' }
    ]
  }
};

export const writingToolboxTemplates = {
  essayTemplates: {
    id: 'essay_templates',
    name: '文章模板',
    templates: [
      {
        id: 'argumentative_template',
        name: '議論文模板',
        type: 'argumentative',
        structure: {
          introduction: '引言（背景 + 論點）',
          body: '正文（論據 + 例子）',
          conclusion: '結論（總結 + 重申）'
        },
        wordDistribution: {
          introduction: 0.15,
          body: 0.7,
          conclusion: 0.15
        }
      },
      {
        id: 'narrative_template',
        name: '記敘文模板',
        type: 'narrative',
        structure: {
          introduction: '開端（背景設定）',
          body: '發展（情節展開）',
          conclusion: '結局（結果反思）'
        },
        wordDistribution: {
          introduction: 0.2,
          body: 0.6,
          conclusion: 0.2
        }
      },
      {
        id: 'descriptive_template',
        name: '描寫文模板',
        type: 'descriptive',
        structure: {
          introduction: '概覽（整體印象）',
          body: '細節（具體描寫）',
          conclusion: '感受（個人體會）'
        },
        wordDistribution: {
          introduction: 0.15,
          body: 0.7,
          conclusion: 0.15
        }
      }
    ]
  },
  
  languageTools: {
    id: 'language_tools',
    name: '語言工具',
    tools: {
      usefulPhrases: {
        id: 'useful_phrases',
        name: '實用短語',
        categories: [
          {
            id: 'introduction_phrases',
            name: '引入',
            phrases: ['最近…', '根據…', '普遍認為…', '眾所周知…', '毫無疑問…']
          },
          {
            id: 'reasoning_phrases',
            name: '給出理由',
            phrases: ['一個原因是…', '此外…', '例如…', '具體來說…', '換言之…']
          },
          {
            id: 'contrast_phrases',
            name: '對比',
            phrases: ['然而…', '另一方面…', '相比之下…', '相反地…', '儘管如此…']
          },
          {
            id: 'conclusion_phrases',
            name: '結論',
            phrases: ['總之…', '總結…', '最終…', '歸根結底…', '一言以蔽之…']
          }
        ]
      },
      
      connectors: {
        id: 'connectors',
        name: '連接詞',
        words: ['首先', '其次', '此外', '而且', '另外', '然而', '因此', '結果', '例如', '總結']
      }
    }
  }
};

export const writingToolboxSettings = {
  defaultSettings: {
    id: 'default_settings',
    name: '預設設定',
    settings: {
      defaultLanguage: 'traditional',
      defaultEssayType: 'general',
      defaultTargetLength: 500,
      defaultTemperature: 0.7,
      defaultMaxTokens: 2000
    }
  },
  
  generationOptions: {
    id: 'generation_options',
    name: '生成選項',
    options: {
      promptOnly: {
        id: 'prompt_only',
        name: '僅生成提示',
        description: '只生成寫作提示，不生成完整文章'
      },
      templateWithOutline: {
        id: 'template_with_outline',
        name: '模板與大綱',
        description: '生成文章模板和詳細大綱'
      },
      fullEssay: {
        id: 'full_essay',
        name: '完整文章',
        description: '生成完整的文章內容'
      }
    }
  }
};

// Helper functions for data access
export const getWritingToolboxData = () => {
  return {
    categories: writingToolboxCategories,
    templates: writingToolboxTemplates,
    settings: writingToolboxSettings
  };
};

export const getCategoryById = (categoryId) => {
  const allCategories = Object.values(writingToolboxCategories);
  for (const category of allCategories) {
    const found = category.items.find(item => item.id === categoryId);
    if (found) return found;
  }
  return null;
};

export const getTemplateById = (templateId) => {
  return writingToolboxTemplates.essayTemplates.templates.find(
    template => template.id === templateId
  );
};

export const getLanguageTools = () => {
  return writingToolboxTemplates.languageTools || {
    usefulPhrases: {
      id: 'useful_phrases',
      name: '實用短語',
      categories: [
        {
          id: 'introduction_phrases',
          name: '引入',
          phrases: ['最近…', '根據…', '普遍認為…', '眾所周知…', '毫無疑問…']
        },
        {
          id: 'reasoning_phrases',
          name: '給出理由',
          phrases: ['一個原因是…', '此外…', '例如…', '具體來說…', '換言之…']
        },
        {
          id: 'contrast_phrases',
          name: '對比',
          phrases: ['然而…', '另一方面…', '相比之下…', '相反地…', '儘管如此…']
        },
        {
          id: 'conclusion_phrases',
          name: '結論',
          phrases: ['總之…', '總結…', '最終…', '歸根結底…', '一言以蔽之…']
        }
      ]
    },
    
    connectors: {
      id: 'connectors',
      name: '連接詞',
      words: ['首先', '其次', '此外', '而且', '另外', '然而', '因此', '結果', '例如', '總結']
    }
  };
}; 